export default "__VITE_ASSET__C7c72vb4__"